// hooks/useScrapeLoraData.ts
import { useMutation } from "@tanstack/react-query";
import { fetch } from "libs";
import { POST_SCRAPE_CIVIT } from "api";

interface ScrapeLoraDataParams {
  url: string;
}

interface ScrapeLoraDataResponse {
  download_link: string;
  trigger_words: string[];
  title: string;
  image_url: string;
  download_count: number
}

export const useScrapeLoraData = () => {
  return useMutation<ScrapeLoraDataResponse, Error, ScrapeLoraDataParams>({
    mutationFn: async ({ url }): Promise<ScrapeLoraDataResponse> => {
      const response = await fetch(`${POST_SCRAPE_CIVIT}?url=${encodeURIComponent(url)}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
   
    
      
      return response
    },
  });
};

export default useScrapeLoraData;